var styles = {"container":"index-module_container__I2ell","ratio-1":"index-module_ratio-1__aTKgx","ratio-4/5":"index-module_ratio-4--5__c27nd","ratio-3/2":"index-module_ratio-3--2__-MsTK","image":"index-module_image__2sWAS","sold":"index-module_sold__-Vyze","placeholder":"index-module_placeholder__XBj0I","count":"index-module_count__Lw7V9"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
